var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"pl-3 pt-1",attrs:{"value":_vm.selected_parc,"items":_vm.parcs,"prepend-icon":"mdi-filter-outline","item-value":"parkcode","item-text":"parkname","label":"Select park","dense":"","clearable":""},on:{"change":_vm.getSelection}})
}
var staticRenderFns = []

export { render, staticRenderFns }